export var SoftHyphenToMarkdown = {
    soft_hyphen: function (state, node) {
        state.write("&shy;");
    }
};
